import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function DonationCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#e8f5f7] to-[#f0f8fa] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        
        {/* Cancel Icon */}
        <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-orange-600" />
        </div>

        <h1 className="text-3xl font-bold text-[#2c5570] mb-4">Donation Cancelled</h1>
        
        <p className="text-[#4a4a4a] text-lg mb-6">
          Your donation was cancelled and no charges were made.
        </p>

        <p className="text-[#4a4a4a] mb-8">
          We understand that timing isn't always right. If you'd like to try again or have any questions, we're here to help.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col gap-3">
          <Button 
            onClick={() => navigate('/donate')}
            className="w-full bg-[#14919f] hover:bg-[#0f7280] text-white rounded-[50px] px-8 py-3 text-lg"
          >
            Try Again
          </Button>
          
          <Button 
            onClick={() => navigate('/')}
            className="w-full bg-white hover:bg-gray-50 text-[#2c5570] border-2 border-[#2c5570] rounded-[50px] px-8 py-3"
          >
            Return to Homepage
          </Button>

          <Button 
            onClick={() => navigate('/contact')}
            className="w-full bg-white hover:bg-gray-50 text-[#4a4a4a] border border-gray-300 rounded-[50px] px-8 py-3"
          >
            Contact Us
          </Button>
        </div>

        {/* Additional Info */}
        <div className="mt-8 p-4 bg-[#e8f5f7] rounded-lg">
          <p className="text-sm text-[#2c5570]">
            Every gift makes a difference. When you're ready, we'll be here to help you change lives through the power of books.
          </p>
        </div>
      </div>
    </div>
  );
}
